import { render, staticRenderFns } from "./ItemUpdateDialogState.vue?vue&type=template&id=60edd492&scoped=true"
import script from "./ItemUpdateDialogState.vue?vue&type=script&lang=ts"
export * from "./ItemUpdateDialogState.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60edd492",
  null
  
)

export default component.exports